"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefectDisplayTitle = getDefectDisplayTitle;
function getDefectDisplayTitle(defect, language) {
    return (language === 'russian' && defect.titleRu) || defect.title;
}
